<div class="pull-right close" (click)="close()">&#10005;</div>
@if (step === 'get-number') {
  <app-mobile-number (closeDialog)="close()"></app-mobile-number>
}
@if (step === 'signin') {
  <app-signin></app-signin>
}
@if (step === 'signup-details') {
  <app-main-signup></app-main-signup>
}
@if (step === 'otp-verification') {
  <app-main-otp-verification (closeDialog)="close()"></app-main-otp-verification>
}
@if (step === 'forgot-password') {
  <app-main-forgot-password></app-main-forgot-password>
}
@if (step === 'add-number') {
  <app-main-change-number></app-main-change-number>
}
@if (step === 'gmail-mobile-verify') {
  <app-gmail-generate-otp></app-gmail-generate-otp>
}
